import Vue from 'vue';
const FpLoaderBus = new Vue();
export default FpLoaderBus;
